<script setup>
import { computed } from 'vue'
import { useMediaQuery } from '@vueuse/core'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from '@/components/ui/drawer'

import { cn } from '@/lib/utils'

const isDesktop = useMediaQuery('(min-width: 640px)')

const Modal = computed(() => ({
  Root: isDesktop.value ? Dialog : Drawer,
  Trigger: isDesktop.value ? DialogTrigger : DrawerTrigger,
  Content: isDesktop.value ? DialogContent : DrawerContent,
  Header: isDesktop.value ? DialogHeader : DrawerHeader,
  Title: isDesktop.value ? DialogTitle : DrawerTitle,
  Description: isDesktop.value ? DialogDescription : DrawerDescription,
  Footer: isDesktop.value ? DialogFooter : DrawerFooter,
  Close: isDesktop.value ? DialogClose : DrawerClose,
}))

const props = defineProps({
    title: {
        type: String,
        required: false
    },
    description: {
        type: String,
        required: false
    },
    modelValue: {
        type: Boolean,
        required: true
    },
    class: {
        type: String,
        required: false
    }
})

const emit = defineEmits(['update:modelValue'])

const open = computed({
    get() {
        return props.modelValue
    },
    set(value) {
        emit('update:modelValue', value)
    }
})
</script>

<template>
  <component :is="Modal.Root" v-model:open="open">
    <component
      :is="Modal.Content"
      :class="[
        cn('sm:max-w-md', props.class),
        { 'px-2 pb-8 *:px-4': !isDesktop },
      ]"
    >
      <component :is="Modal.Header">
        <component :is="Modal.Title">
            <slot name="title">
                {{ title }}
            </slot>
        </component>
        <component :is="Modal.Description">
            <slot name="description">
                {{description}}
            </slot>
        </component>
      </component>

      <slot name="body">
      </slot>

      <slot name="footer">
        <component :is="Modal.Footer" class="pt-4">
          <component :is="Modal.Close" as-child>
            <slot name="close">
                <Button variant="outline">
                    Close
                </Button>
            </slot>
          </component>
        </component>
      </slot>
    </component>
  </component>
</template>
